module.exports = __webpack_public_path__ + "bfc87291ac2aa4025cf18521d6e8d45e.png";